/**
 * Grey placeholder reusing the EventCard frame (kit `.evcard.loading`): surface
 * #F5F5F5, white logo tile with an image glyph, bars where the chips / name /
 * meta row sit. No photo, no blur, no scrim. Same `--u` container unit as the
 * real card so both scale identically inside the grid.
 */

const BAR = 'block rounded-[5px] bg-[#e6e8ef]'
const CHIP = 'inline-block h-[calc(21*var(--u))] rounded-[5px] border border-[#dbdadf] bg-white'

function ImageGlyph() {
    return (
        <svg
            viewBox="0 0 24 24"
            className="h-[calc(22*var(--u))] w-[calc(22*var(--u))]"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden
        >
            <rect x="3" y="4.5" width="18" height="15" rx="2.5" />
            <circle cx="8.5" cy="10" r="1.6" />
            <path d="m4 17 5-4.5 4 3.5 3-2.5 4 3.5" />
        </svg>
    )
}

export default function EventCardSkeleton() {
    return (
        <div
            aria-hidden
            className="@container relative isolate block aspect-395/230 w-full overflow-hidden rounded-[10px] border border-[#dbdadf] bg-[#f5f5f5] text-[#9498a6] animate-pulse motion-reduce:animate-none"
            style={{ '--u': '0.25316cqw' }}
        >
            <div
                className="absolute inset-0 flex flex-col justify-end"
                style={{
                    padding: 'calc(20 * var(--u)) calc(20 * var(--u)) calc(10 * var(--u)) calc(10 * var(--u))',
                }}
            >
                <div className="flex min-w-0 items-end gap-[calc(11*var(--u))]">
                    <span className="grid h-[calc(84*var(--u))] w-[calc(84*var(--u))] flex-none place-items-center rounded-[10px] border border-[#dbdadf] bg-white">
                        <ImageGlyph />
                    </span>

                    <div className="flex min-w-0 flex-1 flex-col gap-[calc(3*var(--u))]">
                        <div className="flex min-h-[calc(21*var(--u))] items-center gap-[calc(9*var(--u))]">
                            <span className={`${CHIP} w-[calc(64*var(--u))]`} />
                            <span className={`${CHIP} w-[calc(96*var(--u))]`} />
                        </div>

                        <span className={`${BAR} h-[calc(18*var(--u))] w-3/4`} />

                        <div className="flex min-h-[calc(17*var(--u))] items-center justify-between gap-[calc(8*var(--u))]">
                            <span className={`${BAR} h-[calc(10*var(--u))] w-[calc(80*var(--u))]`} />
                            <span className={`${BAR} h-[calc(10*var(--u))] w-[calc(96*var(--u))]`} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
